export const NUMBER_REGEX = /^[0-9]+$/;
export const NUMBER_REGEX_EXT = /^[0-9,.]+$/;
